import type { FC, ReactNode } from 'react';
import styles from './styles.module.scss';

type PageHeaderProps = {
	/** The page's title and, after it, whatever acts on the page. */
	children: ReactNode;
};

/**
 * A title row that pushes its last child to the far edge. Belongs in a
 * `PageContainer wide`, otherwise that edge is the 720px cap rather than the
 * page's.
 */
const PageHeader: FC<PageHeaderProps> = ({ children }) => (
	<div className={styles.header}>{children}</div>
);

export default PageHeader;
